<div class="warning-modal" *ngIf="show" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="icon-container" [style.background-color]="getIconBackground()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path [attr.d]="getIconPath()" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h2 class="modal-title">{{ config.title || 'Warning' }}</h2>
      <button class="close-btn" (click)="onClose()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    
    <div class="modal-body">
      <ng-container *ngIf="!config.radioMode">
        <p class="message">{{ config.message }}</p>
        <div class="details" *ngIf="config.showDetails && config.details && config.details.length > 0">
          <div class="detail-row" *ngFor="let detail of config.details">
            <span class="label">{{ detail.label }}</span>
            <span class="value" [ngClass]="detail.type === 'badge' ? getBadgeClass(detail.value) : ''">
              {{ detail.value }}
            </span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="config.radioMode">
        <div class="radio-list">
          <label *ngFor="let option of config.radioOptions" class="radio-option">
            <input type="radio" name="ai-assistant-choice" [value]="option.id" [checked]="selectedRadioId === option.id" (change)="onRadioSelect(option.id)" />
            <span class="radio-icon"></span>
            <span class="radio-label">{{ option.label }}</span>
            <span class="radio-sublabel">{{ option.subLabel }}</span>
          </label>
        </div>
      </ng-container>
    </div>
    
    <div class="modal-footer">
      <button 
        *ngIf="config.secondaryButton" 
        class="btn btn-secondary" 
        (click)="onAction(config.secondaryButton.action)">
        {{ config.secondaryButton.text }}
      </button>
      <button 
        *ngIf="config.primaryButton && !config.radioMode" 
        [ngClass]="getPrimaryButtonClass()"
        (click)="onAction(config.primaryButton.action)">
        <svg *ngIf="config.primaryButton.icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path [attr.d]="config.primaryButton.icon" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ config.primaryButton.text }}
      </button>
    </div>
  </div>
</div> 